(function (
    global,
    $,
    moduleRegistrar,
    Module,
    ImageHelper
) {
    class Gallery
    {
        /**
         * @param {string} id
         * @param {object} options
         * @since 1.0.0
         */
        constructor(id, options= {})
        {
            /**
             * Gallery ID.
             *
             * @type  {string|null}
             * @since 1.0.0
             */
            this.id = id || null;

            /**
             * Gallery grid columns and spacing.
             *
             * @type  {object}
             * @since 1.0.0
             */
            this.sizes = options.sizes || [
                {
                    columns: 1,
                    rowGap: 24
                },
                {
                    breakpoint: 600,
                    columns: 2,
                    rowGap: 24,
                    colGap: 24
                },
                {
                    breakpoint: 900,
                    columns: 3,
                    rowGap: 24,
                    colGap: 24
                },
                {
                    breakpoint: 1200,
                    columns: 4,
                    rowGap: 24,
                    colGap: 24
                }
            ];

            /**
             * Element selectors.
             *
             * @type  {{galleryItems: string, galleryItem: string, gallery: string}}
             * @since 1.0.0
             */
            this.selectors = {
                gallery: '#' + this.id,
                galleryItems: '[data-js="gallery_items"][data-layout="masonry"]',
                galleryItem: '[data-js="gallery_item"]',
            };

            // Abort if gallery doesn't exists.
            if (null === this.id) {
                return;
            }

            // Get gallery images.
            this.images = $(this.selectors.gallery).find(this.selectors.galleryItems).children();

            // Rebuild masonry layout on window resize.
            let resizeTimeout;
            $(window).on('resize', () => {
                clearTimeout(resizeTimeout);
                resizeTimeout = setTimeout(() => {
                    this.buildMasonry();
                }, 250);
            });

            this.buildMasonry();
        }

        /**
         * Builds the masonry layout.
         *
         * @since 1.0.0
         */
        buildMasonry()
        {
            let containerWidth  = $(this.selectors.gallery).find(this.selectors.galleryItems).outerWidth();
            let windowWidth     = $(window).width();
            let sizeProperties  = this.sizes[0];

            // Sizes configured for different breakpoints.
            if (this.sizes.length > 1) {
                /**
                 * @type {object} size
                 * @property {number} size.breakpoint
                 */
                $.each(this.sizes, (index, size) => {
                    if (size.breakpoint && size.breakpoint >= windowWidth) {
                        return;
                    }

                    !size.hasOwnProperty('colGap') ? size.colGap = 0 : null;
                    !size.hasOwnProperty('rowGap') ? size.rowGap = 0 : null;

                    sizeProperties = size;
                });
            }

            // Calculate column width.
            let columnWidth = (containerWidth - (sizeProperties.colGap * (sizeProperties.columns - 1))) / sizeProperties.columns;

            // Variables for image positioning.
            let columnIndex      = 0;
            let horizontalOffset = 0;
            let verticalOffset   = [];
            let columnHeights    = [];

            for (let i = 0; i < sizeProperties.columns; i++) {
                verticalOffset.push(0);
                columnHeights.push(0);
            }

            let resizeContainerTimeout = null;

            // Process each gallery image.
            this.images.each((index, image) => {
                const imageHelper = new ImageHelper($(image).find('img').attr('src'));

                // Show images when loaded.
                imageHelper.isLoaded().then(img => {
                    // Position last images according the column heights, to archive more even heights.
                    if (index >= this.images.length -(sizeProperties.columns -(sizeProperties.columns < 4 ? 1 : 0))) {
                        const lowest = Math.min.apply(null, columnHeights);
                        let shortestColumn = Object.keys(columnHeights).filter(x => { return columnHeights[x] === lowest })[0];
                        columnIndex = shortestColumn;
                        horizontalOffset = columnWidth * shortestColumn  + sizeProperties.colGap * shortestColumn;
                    }

                    columnHeights[columnIndex] += $(image).outerHeight() + sizeProperties.rowGap;

                    // Position gallery image.
                    $(image).css({
                        position: 'absolute',
                        left: horizontalOffset + 'px',
                        top: verticalOffset[columnIndex] + 'px',
                        width: columnWidth
                    });

                    // Calculate horizontal and vertical image offsets for the next images.
                    horizontalOffset += columnWidth + sizeProperties.colGap;
                    verticalOffset[columnIndex] += $(image).outerHeight() + sizeProperties.rowGap;
                    columnIndex++;

                    // Reset horizontal offset and column index, when last column reached.
                    if (0 === columnIndex % sizeProperties.columns) {
                        horizontalOffset = 0;
                        columnIndex = 0;
                    }

                    $(image).css({
                        opacity: 1,
                        filter: 'blur(0)'
                    });

                    clearTimeout(resizeContainerTimeout);

                    // Resize gallery container.
                    resizeContainerTimeout = setTimeout(() => {
                        $(this.selectors.gallery)
                            .find(this.selectors.galleryItems)
                            .css('height', 0);
                        
                        $(this.selectors.gallery)
                            .find(this.selectors.galleryItems)
                            .css('height', $(this.selectors.gallery).find(this.selectors.galleryItems).prop('scrollHeight') + 'px');
                    }, 250);
                }).catch(err => console.error(err));
            });
        }
    }

    moduleRegistrar.register(new Module('webscape-gallery', Gallery));
}) (
    window,
    jQuery,
    window.webSCAPE.moduleRegistrar,
    window.webSCAPE.Module,
    window.webSCAPE.moduleRegistrar.getModule('webscape-image-helper').getClass()
);
